import {NavigatedStepperEventMetadata} from 'analytics/metadata/NavigatedStepperEventMetadata';
import {CommonAnalyticsActions} from 'constants/AnalyticsConstants';

import {MigrationStep} from '../types/MigrationStep';
import {BaseConfigMigrationEventMetadata, trackCommonEvent} from './CommonConfigMigrationAnalytics';

// Metadata
export type ImportPaneNavigationEventMetadata = BaseConfigMigrationEventMetadata &
  NavigatedStepperEventMetadata & {
    origin_step: MigrationStep;
    destination_step: MigrationStep;
    num_items_current_step: number;
  };

// Tracking Function
export function trackNavigatedImportWizard(metadata: ImportPaneNavigationEventMetadata): void {
  trackCommonEvent(CommonAnalyticsActions.NAVIGATED_STEP_COMPONENT, metadata);
}
